import React from 'react';
import IndexPage from './Page.tsx';
import PageFade from '@/common/components/PageFade.tsx';
// loaders go here
// actions go here

const IndexRoute: React.FC = () => {
  return (
    <PageFade>
      <IndexPage />
    </PageFade>
  );
};

export default IndexRoute;
